import React, { useEffect, useState } from "react";
import EmailIcon from "./img/mailIcon.svg";
import Text from "../../component/text/Text";
import "./VerifyEmail.css";
import {
  PrimaryButton,
  LoginBackButton,
} from "../../component/buttonComponent/ButtonComponent";
import OtpInput from "../../component/otpInput/OtpInput";
import { useNavigate, useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import Cookies from "js-cookie";
import FooterImage from "../../image/header.png";
import SnackBar from "../../component/Snackbar/Snackbar";
import { APIVerifyEmail } from "../../config/utilities/APIs";

const emailKey = process.env.REACT_APP_EMAIL_SECRET_KEY;

export default function VerifyEmail() {
  const [otpValue, setOtpValue] = useState("");
  const navigate = useNavigate();

  const params = useParams();
  const token = params["*"];

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarType, setSnackbarType] = useState("");
  const [snackbarTitle, setSnackbarTitle] = useState("");
  const [snackbarSubtitle, setSnackbarSubtitle] = useState("");

  const decryptToken = (encryptedToken) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedToken, emailKey);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      return decryptedData;
    } catch (error) {
      console.error("Decryption failed: ", error.message);
      return null;
    }
  };

  useEffect(() => {
    const userData = token ? decryptToken(token) : null;
    if (!userData || new Date(userData.codeExpireAt) < new Date()) {
      navigate("/invalidlink");
    } else {
      setEmail(userData.email);
      setPassword(userData.password);
    }
  }, [token, navigate]);

  const btnBack = () => {
    navigate("/login", { replace: true });
  };

  const btnVerifyEmail = async () => {
    setLoading(true);

    const verificationData = {
      email,
      code: otpValue,
    };

    try {
      const response = await APIVerifyEmail(verificationData, setLoading);

      if (response.status === 200) {
        // Log the user in using firebase
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        Cookies.remove("verificationEmail");
        navigate("/dashboard");
      } else {
        throw new Error(
          response.response?.data?.message || "Failed to sign up"
        );
      }
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarTitle("Verificaton Failed");
      setSnackbarSubtitle(error.message || "An error occurred");
      setSnackbarType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="verify-email-container">
        <div className="verify-email-content">
          <div className="verify-email-header">
            <div className="email-icon">
              <img src={EmailIcon} loading="lazy" alt="email-icon" />
            </div>
            <Text
              text="Enter verification code"
              size="1.5rem"
              weight="600"
              align="center"
              height="2.375rem"
              lineHeight="2.375rem"
            />
            <Text
              text={` Enter your verification code below to login to the BusBuddy platform. `}
              color="#475467"
              size="0.875rem"
              weight="400"
              align="center"
              height="auto"
              lineHeight="1.5rem"
            />
          </div>
          <div className="otp-container">
            <OtpInput
              value={otpValue}
              valueLength={4}
              setOtpValue={setOtpValue}
            />
          </div>
          <PrimaryButton
            disable={otpValue.length !== 4}
            label="Login"
            onClickFunction={btnVerifyEmail}
            loading={loading}
          />
          <LoginBackButton
            btnClickBack={btnBack}
            label="Back to log in"
            backgroundColor="#FFFFFF"
          />
        </div>
        <div className="login-logo-footer">
          <div className="login-logo">
            <img
              loading="lazy"
              src={FooterImage}
              className="logo"
              alt="header-logo"
            />
          </div>
        </div>
      </div>
      {showSnackbar && (
        <div className="notification">
          <SnackBar
            state={showSnackbar}
            setState={setShowSnackbar}
            title={snackbarTitle}
            subtitle={snackbarSubtitle}
            module={snackbarType}
            action={snackbarType}
          />
        </div>
      )}
    </>
  );
}
